<template>
	<h1 style="margin:50px 0 30px ; font-size: 50px; text-align:center;">에너지넷 파일 리스트</h1>
	<table>
		<thead>
			<tr>
				<th>
					이름
				</th>
				<th>
					URL
				</th>
				<th>
					폴더
				</th>
				<th>
					파일이름
				</th>
				<th>
					기획서페이지
				</th>
			</tr>
		</thead>
		<tbody>
			<tr>
				<td>
					메인 페이지
				</td>
				<td>
					<a target="_blank" href='http://172.233.73.118:7070/'>이동</a> ( http://172.233.73.118:7070/ )
				</td>
				<td>
					/home/vueapp/energynet/src/views/
				</td>
				<td>
					HomePage.vue
				</td>
				<td>
					
				</td>
			</tr>
		</tbody>
	</table>
</template>

<style>
table {
    width: 100%;
    border-collapse: collapse;
		margin-bottom: 50px;
}
th, td {
    border: 1px solid #ddd;
    padding: 8px;
}
th {
    background-color: #f2f2f2;
    text-align: left;
}
td{
	text-align: left;
}
</style>

<script>
export default {
  name: 'FileList'
}
</script>
